module.exports = __webpack_public_path__ + "b08dbddc85eeb7f234b77c5e22c1faaa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg66.jpeg
// module id = 79
// module chunks = 0